/**
 * Dashboard Comments Filter - Aligned with DashboardCueNotesFilter
 * Same structure: CustomFilter only with version2, onResetForm, analytics
 * Fields: Search, Date Range (Created)
 */
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  getDashboardCommentsFilterSpecs,
  defaultCommentsFilterValues,
} from './DashboardFilterUtils';

export const defaultValues = defaultCommentsFilterValues;

export interface DashboardCommentsFilterProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
  onAfterReset?: () => void;
}

export const DashboardCommentsFilter: React.FC<DashboardCommentsFilterProps> = ({
  onApplyFilter,
  onAfterReset,
}) => {
  const { setValue } = useFormContext();
  const fields = useMemo(() => getDashboardCommentsFilterSpecs(), []);

  const resetFilter = () => {
    Object.entries(defaultCommentsFilterValues).forEach(([key, val]) => setValue(key, val));
    onApplyFilter(defaultCommentsFilterValues);
    onAfterReset?.();
  };

  return (
    <CustomFilter
      fields={fields}
      onResetForm={resetFilter}
      justifyContent="flex-start"
      version2
      analytics={{ caller: 'TaskOperations', onApply: true, properties: { category: 'Dashboard Comments' } }}
    />
  );
};
